export default function LogoHome({ size = 100 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: "block", margin: "0 auto", marginBottom: 10 }}
    >
      {/* Toit */}
      <polygon points="35,8 4,34 66,34" fill="#356097" />
      {/* Corps */}
      <rect x="12" y="34" width="46" height="28" fill="#4F86C6" />
      {/* Porte */}
      <rect x="31" y="46" width="8" height="16" fill="#E6ECF2" />
      {/* Fenêtre gauche */}
      <rect x="18" y="40" width="8" height="8" fill="#E6ECF2" />
      {/* Fenêtre droite */}
      <rect x="44" y="40" width="8" height="8" fill="#E6ECF2" />
    </svg>
  );
}